//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.2.0.0 (NJsonSchema v11.1.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import { AuthorizedApiClientBase } from "../../../../components/Auth/AuthorizedApiClientBase";

export class PortfoliosClient extends AuthorizedApiClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return Success
     */
    addPortfolio(root: AddPortfolio_Request_Root): Promise<AddPortfolio_Response_Root> {
        let url_ = this.baseUrl + "/api/portfolios/portfolio";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(root);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processAddPortfolio(_response);
        });
    }

    protected processAddPortfolio(response: Response): Promise<AddPortfolio_Response_Root> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AddPortfolio_Response_Root.fromJS(resultData200);
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = FastEndpointsErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AddPortfolio_Response_Root>(null as any);
    }

    /**
     * Get active standing orders for a portfolio
     * @return Standing orders retrieved successfully
     */
    getActiveStandingOrdersForPortfolio(portfolioId: string): Promise<GetActiveStandingOrdersForPortfolio_Response_Root> {
        let url_ = this.baseUrl + "/api/portfolios/{portfolioId}/standing-orders";
        if (portfolioId === undefined || portfolioId === null)
            throw new Error("The parameter 'portfolioId' must be defined.");
        url_ = url_.replace("{portfolioId}", encodeURIComponent("" + portfolioId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetActiveStandingOrdersForPortfolio(_response);
        });
    }

    protected processGetActiveStandingOrdersForPortfolio(response: Response): Promise<GetActiveStandingOrdersForPortfolio_Response_Root> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetActiveStandingOrdersForPortfolio_Response_Root.fromJS(resultData200);
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = FastEndpointsErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetActiveStandingOrdersForPortfolio_Response_Root>(null as any);
    }

    /**
     * @return Success
     */
    getAvailableFunds(): Promise<GetAvailableFunds_Response_Root> {
        let url_ = this.baseUrl + "/api/portfolios/funds/available";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAvailableFunds(_response);
        });
    }

    protected processGetAvailableFunds(response: Response): Promise<GetAvailableFunds_Response_Root> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetAvailableFunds_Response_Root.fromJS(resultData200);
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetAvailableFunds_Response_Root>(null as any);
    }

    /**
     * @return Success
     */
    getDeposit(depositId: string): Promise<GetDeposit_Response_Root> {
        let url_ = this.baseUrl + "/api/portfolios/deposit/{depositId}";
        if (depositId === undefined || depositId === null)
            throw new Error("The parameter 'depositId' must be defined.");
        url_ = url_.replace("{depositId}", encodeURIComponent("" + depositId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetDeposit(_response);
        });
    }

    protected processGetDeposit(response: Response): Promise<GetDeposit_Response_Root> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetDeposit_Response_Root.fromJS(resultData200);
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = FastEndpointsErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetDeposit_Response_Root>(null as any);
    }

    /**
     * Get the deposit reference for a JISA account
     * @return Success
     */
    getJisaDepositReference(portfolioId: string): Promise<GetJisaDepositReference_Response> {
        let url_ = this.baseUrl + "/api/portfolios/jisa/deposit-reference?";
        if (portfolioId === undefined || portfolioId === null)
            throw new Error("The parameter 'portfolioId' must be defined and cannot be null.");
        else
            url_ += "portfolioId=" + encodeURIComponent("" + portfolioId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetJisaDepositReference(_response);
        });
    }

    protected processGetJisaDepositReference(response: Response): Promise<GetJisaDepositReference_Response> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetJisaDepositReference_Response.fromJS(resultData200);
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = FastEndpointsErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetJisaDepositReference_Response>(null as any);
    }

    /**
     * Creates a Plaid payment/deposit request, and returns the Payment Initiation link token.
     * @return Success
     */
    getOpenBankingStatus(portfolioId: string): Promise<GetOpenBankingStatus_Response> {
        let url_ = this.baseUrl + "/api/portfolios/portfolio/{portfolioId}/plaid-deposit";
        if (portfolioId === undefined || portfolioId === null)
            throw new Error("The parameter 'portfolioId' must be defined.");
        url_ = url_.replace("{portfolioId}", encodeURIComponent("" + portfolioId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetOpenBankingStatus(_response);
        });
    }

    protected processGetOpenBankingStatus(response: Response): Promise<GetOpenBankingStatus_Response> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetOpenBankingStatus_Response.fromJS(resultData200);
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetOpenBankingStatus_Response>(null as any);
    }

    /**
     * Creates a Plaid payment/deposit request, and returns the Payment Initiation link token.
     * @return Success
     */
    requestPlaidDepositToPortfolio(request: RequestPlaidDepositToPortfolio_Request, portfolioId: string): Promise<RequestPlaidDepositToPortfolio_Response> {
        let url_ = this.baseUrl + "/api/portfolios/portfolio/{portfolioId}/plaid-deposit";
        if (portfolioId === undefined || portfolioId === null)
            throw new Error("The parameter 'portfolioId' must be defined.");
        url_ = url_.replace("{portfolioId}", encodeURIComponent("" + portfolioId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processRequestPlaidDepositToPortfolio(_response);
        });
    }

    protected processRequestPlaidDepositToPortfolio(response: Response): Promise<RequestPlaidDepositToPortfolio_Response> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RequestPlaidDepositToPortfolio_Response.fromJS(resultData200);
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = FastEndpointsErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RequestPlaidDepositToPortfolio_Response>(null as any);
    }

    /**
     * @return Success
     */
    getPortfolioAllowance(portfolioId: string): Promise<GetPortfolioAllowance_Response> {
        let url_ = this.baseUrl + "/api/portfolios/portfolio/{portfolioId}/allowance";
        if (portfolioId === undefined || portfolioId === null)
            throw new Error("The parameter 'portfolioId' must be defined.");
        url_ = url_.replace("{portfolioId}", encodeURIComponent("" + portfolioId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetPortfolioAllowance(_response);
        });
    }

    protected processGetPortfolioAllowance(response: Response): Promise<GetPortfolioAllowance_Response> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetPortfolioAllowance_Response.fromJS(resultData200);
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = FastEndpointsErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetPortfolioAllowance_Response>(null as any);
    }

    /**
     * @return Success
     */
    getPortfolioAvailableActions(portfolioId: string): Promise<GetPortfolioAvailableActions_Response> {
        let url_ = this.baseUrl + "/api/portfolios/portfolio/{portfolioId}/actions";
        if (portfolioId === undefined || portfolioId === null)
            throw new Error("The parameter 'portfolioId' must be defined.");
        url_ = url_.replace("{portfolioId}", encodeURIComponent("" + portfolioId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetPortfolioAvailableActions(_response);
        });
    }

    protected processGetPortfolioAvailableActions(response: Response): Promise<GetPortfolioAvailableActions_Response> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetPortfolioAvailableActions_Response.fromJS(resultData200);
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = FastEndpointsErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetPortfolioAvailableActions_Response>(null as any);
    }

    /**
     * @return Success
     */
    getPortfolioBalance(portfolioId: string): Promise<GetPortfolioBalance_Response> {
        let url_ = this.baseUrl + "/api/portfolios/portfolio/{portfolioId}/balance";
        if (portfolioId === undefined || portfolioId === null)
            throw new Error("The parameter 'portfolioId' must be defined.");
        url_ = url_.replace("{portfolioId}", encodeURIComponent("" + portfolioId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetPortfolioBalance(_response);
        });
    }

    protected processGetPortfolioBalance(response: Response): Promise<GetPortfolioBalance_Response> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetPortfolioBalance_Response.fromJS(resultData200);
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = FastEndpointsErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetPortfolioBalance_Response>(null as any);
    }

    /**
     * @return Success
     */
    getPortfolioFees(portfolioId: string): Promise<GetPortfolioFees_Response> {
        let url_ = this.baseUrl + "/api/portfolios/portfolio/{portfolioId}/fees";
        if (portfolioId === undefined || portfolioId === null)
            throw new Error("The parameter 'portfolioId' must be defined.");
        url_ = url_.replace("{portfolioId}", encodeURIComponent("" + portfolioId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetPortfolioFees(_response);
        });
    }

    protected processGetPortfolioFees(response: Response): Promise<GetPortfolioFees_Response> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetPortfolioFees_Response.fromJS(resultData200);
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = FastEndpointsErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetPortfolioFees_Response>(null as any);
    }

    /**
     * @return Success
     */
    getPortfolioRequestsForAccount(accountId: string): Promise<GetPortfolioRequestsForAccount_Response_Root> {
        let url_ = this.baseUrl + "/api/portfolios/account/{accountId}/portfolio-requests";
        if (accountId === undefined || accountId === null)
            throw new Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetPortfolioRequestsForAccount(_response);
        });
    }

    protected processGetPortfolioRequestsForAccount(response: Response): Promise<GetPortfolioRequestsForAccount_Response_Root> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetPortfolioRequestsForAccount_Response_Root.fromJS(resultData200);
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = FastEndpointsErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetPortfolioRequestsForAccount_Response_Root>(null as any);
    }

    /**
     * @return Success
     */
    getPortfoliosForAccount(accountId: string): Promise<GetPortfoliosForAccount_Response_Root> {
        let url_ = this.baseUrl + "/api/portfolios/account/{accountId}/portfolios";
        if (accountId === undefined || accountId === null)
            throw new Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetPortfoliosForAccount(_response);
        });
    }

    protected processGetPortfoliosForAccount(response: Response): Promise<GetPortfoliosForAccount_Response_Root> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetPortfoliosForAccount_Response_Root.fromJS(resultData200);
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = FastEndpointsErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetPortfoliosForAccount_Response_Root>(null as any);
    }

    /**
     * @return Success
     */
    getPortfolioTransactions(portfolioId: string): Promise<GetPortfolioTransactions_Response> {
        let url_ = this.baseUrl + "/api/portfolios/portfolio/{portfolioId}/transactions";
        if (portfolioId === undefined || portfolioId === null)
            throw new Error("The parameter 'portfolioId' must be defined.");
        url_ = url_.replace("{portfolioId}", encodeURIComponent("" + portfolioId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetPortfolioTransactions(_response);
        });
    }

    protected processGetPortfolioTransactions(response: Response): Promise<GetPortfolioTransactions_Response> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetPortfolioTransactions_Response.fromJS(resultData200);
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = FastEndpointsErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetPortfolioTransactions_Response>(null as any);
    }

    /**
     * @return Success
     */
    getPortfolioValuations(portfolioId: string, limit: number): Promise<GetPortfolioValuations_Response> {
        let url_ = this.baseUrl + "/api/portfolios/portfolio/{portfolioId}/valuations?";
        if (portfolioId === undefined || portfolioId === null)
            throw new Error("The parameter 'portfolioId' must be defined.");
        url_ = url_.replace("{portfolioId}", encodeURIComponent("" + portfolioId));
        if (limit === undefined || limit === null)
            throw new Error("The parameter 'limit' must be defined and cannot be null.");
        else
            url_ += "limit=" + encodeURIComponent("" + limit) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetPortfolioValuations(_response);
        });
    }

    protected processGetPortfolioValuations(response: Response): Promise<GetPortfolioValuations_Response> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetPortfolioValuations_Response.fromJS(resultData200);
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = FastEndpointsErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetPortfolioValuations_Response>(null as any);
    }

    /**
     * @return No Content
     */
    makeWithdrawal(request: MakeWithdrawal_Request, portfolioId: string): Promise<void> {
        let url_ = this.baseUrl + "/api/portfolios/{portfolioId}/withdraw";
        if (portfolioId === undefined || portfolioId === null)
            throw new Error("The parameter 'portfolioId' must be defined.");
        url_ = url_.replace("{portfolioId}", encodeURIComponent("" + portfolioId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processMakeWithdrawal(_response);
        });
    }

    protected processMakeWithdrawal(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    requestDepositToPortfolio(request: RequestDepositToPortfolio_Request, portfolioId: string): Promise<RequestDepositToPortfolio_Response> {
        let url_ = this.baseUrl + "/api/portfolios/portfolio/{portfolioId}/deposit";
        if (portfolioId === undefined || portfolioId === null)
            throw new Error("The parameter 'portfolioId' must be defined.");
        url_ = url_.replace("{portfolioId}", encodeURIComponent("" + portfolioId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processRequestDepositToPortfolio(_response);
        });
    }

    protected processRequestDepositToPortfolio(response: Response): Promise<RequestDepositToPortfolio_Response> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RequestDepositToPortfolio_Response.fromJS(resultData200);
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = FastEndpointsErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RequestDepositToPortfolio_Response>(null as any);
    }

    /**
     * @return No Content
     */
    requestRebalance(request: RequestRebalance_Request, portfolioId: string): Promise<void> {
        let url_ = this.baseUrl + "/api/portfolios/portfolio/{portfolioId}/allocations";
        if (portfolioId === undefined || portfolioId === null)
            throw new Error("The parameter 'portfolioId' must be defined.");
        url_ = url_.replace("{portfolioId}", encodeURIComponent("" + portfolioId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processRequestRebalance(_response);
        });
    }

    protected processRequestRebalance(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = FastEndpointsErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Creates a Plaid payment/deposit request for accounts without a linked PlaidAccount
     * @return Success
     */
    requestUnlinkedPlaidDepositToPortfolio(request: RequestUnlinkedPlaidDepositToPortfolio_Request, portfolioId: string): Promise<RequestUnlinkedPlaidDepositToPortfolio_Response> {
        let url_ = this.baseUrl + "/api/portfolios/portfolio/{portfolioId}/unlinked-plaid-deposit";
        if (portfolioId === undefined || portfolioId === null)
            throw new Error("The parameter 'portfolioId' must be defined.");
        url_ = url_.replace("{portfolioId}", encodeURIComponent("" + portfolioId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processRequestUnlinkedPlaidDepositToPortfolio(_response);
        });
    }

    protected processRequestUnlinkedPlaidDepositToPortfolio(response: Response): Promise<RequestUnlinkedPlaidDepositToPortfolio_Response> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RequestUnlinkedPlaidDepositToPortfolio_Response.fromJS(resultData200);
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = FastEndpointsErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RequestUnlinkedPlaidDepositToPortfolio_Response>(null as any);
    }

    /**
     * @return Success
     */
    tradingInternalApiHealthCheck(): Promise<TradingInternalApiHealthCheck_Response> {
        let url_ = this.baseUrl + "/api/portfolios/trading-internal-api/health";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processTradingInternalApiHealthCheck(_response);
        });
    }

    protected processTradingInternalApiHealthCheck(response: Response): Promise<TradingInternalApiHealthCheck_Response> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TradingInternalApiHealthCheck_Response.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TradingInternalApiHealthCheck_Response>(null as any);
    }

    /**
     * @return No Content
     */
    updatePortfolioFundSelection(root: UpdatePortfolioFundSelection_Request_Root, portfolioId: string): Promise<void> {
        let url_ = this.baseUrl + "/api/portfolios/portfolio/{portfolioId}";
        if (portfolioId === undefined || portfolioId === null)
            throw new Error("The parameter 'portfolioId' must be defined.");
        url_ = url_.replace("{portfolioId}", encodeURIComponent("" + portfolioId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(root);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdatePortfolioFundSelection(_response);
        });
    }

    protected processUpdatePortfolioFundSelection(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = FastEndpointsErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Pings the portfolios service to avoid long cold starts
     * @return No Content
     */
    warmup(): Promise<void> {
        let url_ = this.baseUrl + "/api/portfolios/warmup";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processWarmup(_response);
        });
    }

    protected processWarmup(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Creates a shareable gift link for a JISA portfolio
     * @return Success
     */
    giftCreateJisaGiftLink(portfolioId: string): Promise<GiftCreateJisaGiftLink_Response> {
        let url_ = this.baseUrl + "/api/portfolios/portfolio/{portfolioId}/gift-link";
        if (portfolioId === undefined || portfolioId === null)
            throw new Error("The parameter 'portfolioId' must be defined.");
        url_ = url_.replace("{portfolioId}", encodeURIComponent("" + portfolioId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGiftCreateJisaGiftLink(_response);
        });
    }

    protected processGiftCreateJisaGiftLink(response: Response): Promise<GiftCreateJisaGiftLink_Response> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GiftCreateJisaGiftLink_Response.fromJS(resultData200);
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GiftCreateJisaGiftLink_Response>(null as any);
    }

    /**
     * Gets all gift notes for a JISA portfolio
     * @return Success
     */
    giftGetGiftPayments(portfolioId: string): Promise<GiftGetGiftPayments_Response_Root> {
        let url_ = this.baseUrl + "/api/portfolios/portfolio/{portfolioId}/gift-notes";
        if (portfolioId === undefined || portfolioId === null)
            throw new Error("The parameter 'portfolioId' must be defined.");
        url_ = url_.replace("{portfolioId}", encodeURIComponent("" + portfolioId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGiftGetGiftPayments(_response);
        });
    }

    protected processGiftGetGiftPayments(response: Response): Promise<GiftGetGiftPayments_Response_Root> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GiftGetGiftPayments_Response_Root.fromJS(resultData200);
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GiftGetGiftPayments_Response_Root>(null as any);
    }

    /**
     * Gets all gift links for a JISA portfolio
     * @return Success
     */
    giftGetJisaGiftLinks(portfolioId: string): Promise<GiftGetJisaGiftLinks_Response_Root> {
        let url_ = this.baseUrl + "/api/portfolios/portfolio/{portfolioId}/gift-links";
        if (portfolioId === undefined || portfolioId === null)
            throw new Error("The parameter 'portfolioId' must be defined.");
        url_ = url_.replace("{portfolioId}", encodeURIComponent("" + portfolioId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGiftGetJisaGiftLinks(_response);
        });
    }

    protected processGiftGetJisaGiftLinks(response: Response): Promise<GiftGetJisaGiftLinks_Response_Root> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GiftGetJisaGiftLinks_Response_Root.fromJS(resultData200);
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GiftGetJisaGiftLinks_Response_Root>(null as any);
    }

    /**
     * Marks a gift note as read
     * @return No Content
     */
    giftMarkGiftNoteRead(portfolioId: string, paymentId: string): Promise<void> {
        let url_ = this.baseUrl + "/api/portfolios/portfolio/{portfolioId}/gift-notes/{paymentId}/read";
        if (portfolioId === undefined || portfolioId === null)
            throw new Error("The parameter 'portfolioId' must be defined.");
        url_ = url_.replace("{portfolioId}", encodeURIComponent("" + portfolioId));
        if (paymentId === undefined || paymentId === null)
            throw new Error("The parameter 'paymentId' must be defined.");
        url_ = url_.replace("{paymentId}", encodeURIComponent("" + paymentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGiftMarkGiftNoteRead(_response);
        });
    }

    protected processGiftMarkGiftNoteRead(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Requests a guest gift deposit via Plaid
     * @return Success
     */
    giftRequestGuestGiftDeposit(request: GiftRequestGuestGiftDeposit_Request, inviteToken: string): Promise<GiftRequestGuestGiftDeposit_Response> {
        let url_ = this.baseUrl + "/api/portfolios/guest/gift/{inviteToken}/deposit";
        if (inviteToken === undefined || inviteToken === null)
            throw new Error("The parameter 'inviteToken' must be defined.");
        url_ = url_.replace("{inviteToken}", encodeURIComponent("" + inviteToken));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGiftRequestGuestGiftDeposit(_response);
        });
    }

    protected processGiftRequestGuestGiftDeposit(response: Response): Promise<GiftRequestGuestGiftDeposit_Response> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GiftRequestGuestGiftDeposit_Response.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = FastEndpointsErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GiftRequestGuestGiftDeposit_Response>(null as any);
    }

    /**
     * Revokes a JISA gift link
     * @return No Content
     */
    giftRevokeJisaGiftLink(inviteId: string): Promise<void> {
        let url_ = this.baseUrl + "/api/portfolios/gift-link/{inviteId}";
        if (inviteId === undefined || inviteId === null)
            throw new Error("The parameter 'inviteId' must be defined.");
        url_ = url_.replace("{inviteId}", encodeURIComponent("" + inviteId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGiftRevokeJisaGiftLink(_response);
        });
    }

    protected processGiftRevokeJisaGiftLink(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Submits a gift note for a guest payment
     * @return Success
     */
    giftSubmitGiftNote(request: GiftSubmitGiftNote_Request): Promise<GiftSubmitGiftNote_Response> {
        let url_ = this.baseUrl + "/api/portfolios/guest/gift/note";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGiftSubmitGiftNote(_response);
        });
    }

    protected processGiftSubmitGiftNote(response: Response): Promise<GiftSubmitGiftNote_Response> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GiftSubmitGiftNote_Response.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = FastEndpointsErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GiftSubmitGiftNote_Response>(null as any);
    }
}

export class AddPortfolio_Response_Root implements IAddPortfolio_Response_Root {
    portfolioId?: string;

    constructor(data?: IAddPortfolio_Response_Root) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.portfolioId = _data["portfolioId"];
        }
    }

    static fromJS(data: any): AddPortfolio_Response_Root {
        data = typeof data === 'object' ? data : {};
        let result = new AddPortfolio_Response_Root();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["portfolioId"] = this.portfolioId;
        return data;
    }
}

export interface IAddPortfolio_Response_Root {
    portfolioId?: string;
}

/** the dto used to send an error response to the client */
export class FastEndpointsErrorResponse implements IFastEndpointsErrorResponse {
    /** the http status code sent to the client. default is 400. */
    statusCode?: number;
    /** the message for the error response */
    message?: string;
    /** the collection of errors for the current context */
    errors?: { [key: string]: string[]; };

    constructor(data?: IFastEndpointsErrorResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.statusCode = 400;
            this.message = "One or more errors occurred!";
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statusCode = _data["statusCode"] !== undefined ? _data["statusCode"] : 400;
            this.message = _data["message"] !== undefined ? _data["message"] : "One or more errors occurred!";
            if (_data["errors"]) {
                this.errors = {} as any;
                for (let key in _data["errors"]) {
                    if (_data["errors"].hasOwnProperty(key))
                        (<any>this.errors)![key] = _data["errors"][key] !== undefined ? _data["errors"][key] : [];
                }
            }
        }
    }

    static fromJS(data: any): FastEndpointsErrorResponse {
        data = typeof data === 'object' ? data : {};
        let result = new FastEndpointsErrorResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusCode"] = this.statusCode;
        data["message"] = this.message;
        if (this.errors) {
            data["errors"] = {};
            for (let key in this.errors) {
                if (this.errors.hasOwnProperty(key))
                    (<any>data["errors"])[key] = (<any>this.errors)[key];
            }
        }
        return data;
    }
}

/** the dto used to send an error response to the client */
export interface IFastEndpointsErrorResponse {
    /** the http status code sent to the client. default is 400. */
    statusCode?: number;
    /** the message for the error response */
    message?: string;
    /** the collection of errors for the current context */
    errors?: { [key: string]: string[]; };
}

export class AddPortfolio_Request_Root implements IAddPortfolio_Request_Root {
    accountId?: string;
    fundAllocations!: AddPortfolio_Request_FundAllocation[];

    constructor(data?: IAddPortfolio_Request_Root) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.fundAllocations = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accountId = _data["accountId"];
            if (Array.isArray(_data["fundAllocations"])) {
                this.fundAllocations = [] as any;
                for (let item of _data["fundAllocations"])
                    this.fundAllocations!.push(AddPortfolio_Request_FundAllocation.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AddPortfolio_Request_Root {
        data = typeof data === 'object' ? data : {};
        let result = new AddPortfolio_Request_Root();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountId"] = this.accountId;
        if (Array.isArray(this.fundAllocations)) {
            data["fundAllocations"] = [];
            for (let item of this.fundAllocations)
                data["fundAllocations"].push(item.toJSON());
        }
        return data;
    }
}

export interface IAddPortfolio_Request_Root {
    accountId?: string;
    fundAllocations: AddPortfolio_Request_FundAllocation[];
}

export class AddPortfolio_Request_FundAllocation implements IAddPortfolio_Request_FundAllocation {
    fundIsin?: string | undefined;
    allocationPercentage?: number;

    constructor(data?: IAddPortfolio_Request_FundAllocation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fundIsin = _data["fundIsin"];
            this.allocationPercentage = _data["allocationPercentage"];
        }
    }

    static fromJS(data: any): AddPortfolio_Request_FundAllocation {
        data = typeof data === 'object' ? data : {};
        let result = new AddPortfolio_Request_FundAllocation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fundIsin"] = this.fundIsin;
        data["allocationPercentage"] = this.allocationPercentage;
        return data;
    }
}

export interface IAddPortfolio_Request_FundAllocation {
    fundIsin?: string | undefined;
    allocationPercentage?: number;
}

export class GetActiveStandingOrdersForPortfolio_Response_Root implements IGetActiveStandingOrdersForPortfolio_Response_Root {
    standingOrders?: GetActiveStandingOrdersForPortfolio_Response_StandingOrderResponse[] | undefined;

    constructor(data?: IGetActiveStandingOrdersForPortfolio_Response_Root) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["standingOrders"])) {
                this.standingOrders = [] as any;
                for (let item of _data["standingOrders"])
                    this.standingOrders!.push(GetActiveStandingOrdersForPortfolio_Response_StandingOrderResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetActiveStandingOrdersForPortfolio_Response_Root {
        data = typeof data === 'object' ? data : {};
        let result = new GetActiveStandingOrdersForPortfolio_Response_Root();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.standingOrders)) {
            data["standingOrders"] = [];
            for (let item of this.standingOrders)
                data["standingOrders"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetActiveStandingOrdersForPortfolio_Response_Root {
    standingOrders?: GetActiveStandingOrdersForPortfolio_Response_StandingOrderResponse[] | undefined;
}

export class GetActiveStandingOrdersForPortfolio_Response_StandingOrderResponse implements IGetActiveStandingOrdersForPortfolio_Response_StandingOrderResponse {
    id?: string;
    amount?: number;
    reference?: string | undefined;
    frequencyType?: PropellePortfoliosCoreApplicationDomainStandingOrderFrequency;
    startDate?: Date;
    intervalExecutionDay?: number;

    constructor(data?: IGetActiveStandingOrdersForPortfolio_Response_StandingOrderResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.amount = _data["amount"];
            this.reference = _data["reference"];
            this.frequencyType = _data["frequencyType"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.intervalExecutionDay = _data["intervalExecutionDay"];
        }
    }

    static fromJS(data: any): GetActiveStandingOrdersForPortfolio_Response_StandingOrderResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetActiveStandingOrdersForPortfolio_Response_StandingOrderResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["amount"] = this.amount;
        data["reference"] = this.reference;
        data["frequencyType"] = this.frequencyType;
        data["startDate"] = this.startDate ? formatDate(this.startDate) : <any>undefined;
        data["intervalExecutionDay"] = this.intervalExecutionDay;
        return data;
    }
}

export interface IGetActiveStandingOrdersForPortfolio_Response_StandingOrderResponse {
    id?: string;
    amount?: number;
    reference?: string | undefined;
    frequencyType?: PropellePortfoliosCoreApplicationDomainStandingOrderFrequency;
    startDate?: Date;
    intervalExecutionDay?: number;
}

export enum PropellePortfoliosCoreApplicationDomainStandingOrderFrequency {
    Weekly = "Weekly",
    Monthly = "Monthly",
}

export class GetActiveStandingOrdersForPortfolio_Request_Root implements IGetActiveStandingOrdersForPortfolio_Request_Root {

    constructor(data?: IGetActiveStandingOrdersForPortfolio_Request_Root) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): GetActiveStandingOrdersForPortfolio_Request_Root {
        data = typeof data === 'object' ? data : {};
        let result = new GetActiveStandingOrdersForPortfolio_Request_Root();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IGetActiveStandingOrdersForPortfolio_Request_Root {
}

export class GetAvailableFunds_Response_Root implements IGetAvailableFunds_Response_Root {
    funds?: GetAvailableFunds_Response_Fund[] | undefined;

    constructor(data?: IGetAvailableFunds_Response_Root) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["funds"])) {
                this.funds = [] as any;
                for (let item of _data["funds"])
                    this.funds!.push(GetAvailableFunds_Response_Fund.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetAvailableFunds_Response_Root {
        data = typeof data === 'object' ? data : {};
        let result = new GetAvailableFunds_Response_Root();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.funds)) {
            data["funds"] = [];
            for (let item of this.funds)
                data["funds"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetAvailableFunds_Response_Root {
    funds?: GetAvailableFunds_Response_Fund[] | undefined;
}

export class GetAvailableFunds_Response_Fund implements IGetAvailableFunds_Response_Fund {
    isin?: string | undefined;

    constructor(data?: IGetAvailableFunds_Response_Fund) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isin = _data["isin"];
        }
    }

    static fromJS(data: any): GetAvailableFunds_Response_Fund {
        data = typeof data === 'object' ? data : {};
        let result = new GetAvailableFunds_Response_Fund();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isin"] = this.isin;
        return data;
    }
}

export interface IGetAvailableFunds_Response_Fund {
    isin?: string | undefined;
}

export class GetDeposit_Response_Root implements IGetDeposit_Response_Root {
    reference?: string | undefined;
    amount?: number;
    status?: string | undefined;

    constructor(data?: IGetDeposit_Response_Root) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.reference = _data["reference"];
            this.amount = _data["amount"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): GetDeposit_Response_Root {
        data = typeof data === 'object' ? data : {};
        let result = new GetDeposit_Response_Root();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reference"] = this.reference;
        data["amount"] = this.amount;
        data["status"] = this.status;
        return data;
    }
}

export interface IGetDeposit_Response_Root {
    reference?: string | undefined;
    amount?: number;
    status?: string | undefined;
}

export class GetDeposit_Request_Root implements IGetDeposit_Request_Root {

    constructor(data?: IGetDeposit_Request_Root) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): GetDeposit_Request_Root {
        data = typeof data === 'object' ? data : {};
        let result = new GetDeposit_Request_Root();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IGetDeposit_Request_Root {
}

export class GetJisaDepositReference_Response implements IGetJisaDepositReference_Response {
    reference?: string | undefined;

    constructor(data?: IGetJisaDepositReference_Response) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.reference = _data["reference"];
        }
    }

    static fromJS(data: any): GetJisaDepositReference_Response {
        data = typeof data === 'object' ? data : {};
        let result = new GetJisaDepositReference_Response();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reference"] = this.reference;
        return data;
    }
}

export interface IGetJisaDepositReference_Response {
    reference?: string | undefined;
}

export class GetJisaDepositReference_Request implements IGetJisaDepositReference_Request {

    constructor(data?: IGetJisaDepositReference_Request) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): GetJisaDepositReference_Request {
        data = typeof data === 'object' ? data : {};
        let result = new GetJisaDepositReference_Request();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IGetJisaDepositReference_Request {
}

export class GetOpenBankingStatus_Response implements IGetOpenBankingStatus_Response {
    isReadyForDeposit?: boolean;

    constructor(data?: IGetOpenBankingStatus_Response) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isReadyForDeposit = _data["isReadyForDeposit"];
        }
    }

    static fromJS(data: any): GetOpenBankingStatus_Response {
        data = typeof data === 'object' ? data : {};
        let result = new GetOpenBankingStatus_Response();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isReadyForDeposit"] = this.isReadyForDeposit;
        return data;
    }
}

export interface IGetOpenBankingStatus_Response {
    isReadyForDeposit?: boolean;
}

export class GetOpenBankingStatus_Request implements IGetOpenBankingStatus_Request {

    constructor(data?: IGetOpenBankingStatus_Request) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): GetOpenBankingStatus_Request {
        data = typeof data === 'object' ? data : {};
        let result = new GetOpenBankingStatus_Request();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IGetOpenBankingStatus_Request {
}

export class GetPortfolioAllowance_Response implements IGetPortfolioAllowance_Response {
    maximumContribution?: number | undefined;

    constructor(data?: IGetPortfolioAllowance_Response) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.maximumContribution = _data["maximumContribution"];
        }
    }

    static fromJS(data: any): GetPortfolioAllowance_Response {
        data = typeof data === 'object' ? data : {};
        let result = new GetPortfolioAllowance_Response();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["maximumContribution"] = this.maximumContribution;
        return data;
    }
}

export interface IGetPortfolioAllowance_Response {
    maximumContribution?: number | undefined;
}

export class GetPortfolioAllowance_Request implements IGetPortfolioAllowance_Request {

    constructor(data?: IGetPortfolioAllowance_Request) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): GetPortfolioAllowance_Request {
        data = typeof data === 'object' ? data : {};
        let result = new GetPortfolioAllowance_Request();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IGetPortfolioAllowance_Request {
}

export class GetPortfolioAvailableActions_Response implements IGetPortfolioAvailableActions_Response {
    actions?: GetPortfolioAvailableActions_ActionResponse[] | undefined;

    constructor(data?: IGetPortfolioAvailableActions_Response) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["actions"])) {
                this.actions = [] as any;
                for (let item of _data["actions"])
                    this.actions!.push(GetPortfolioAvailableActions_ActionResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetPortfolioAvailableActions_Response {
        data = typeof data === 'object' ? data : {};
        let result = new GetPortfolioAvailableActions_Response();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.actions)) {
            data["actions"] = [];
            for (let item of this.actions)
                data["actions"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetPortfolioAvailableActions_Response {
    actions?: GetPortfolioAvailableActions_ActionResponse[] | undefined;
}

export class GetPortfolioAvailableActions_ActionResponse implements IGetPortfolioAvailableActions_ActionResponse {
    action?: GetPortfolioAvailableActions_Action;
    allowed?: boolean;
    reason?: string | undefined;

    constructor(data?: IGetPortfolioAvailableActions_ActionResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.action = _data["action"];
            this.allowed = _data["allowed"];
            this.reason = _data["reason"];
        }
    }

    static fromJS(data: any): GetPortfolioAvailableActions_ActionResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetPortfolioAvailableActions_ActionResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["action"] = this.action;
        data["allowed"] = this.allowed;
        data["reason"] = this.reason;
        return data;
    }
}

export interface IGetPortfolioAvailableActions_ActionResponse {
    action?: GetPortfolioAvailableActions_Action;
    allowed?: boolean;
    reason?: string | undefined;
}

export enum GetPortfolioAvailableActions_Action {
    Withdrawal = "Withdrawal",
    Deposit = "Deposit",
    Rebalance = "Rebalance",
}

export class GetPortfolioAvailableActions_Request implements IGetPortfolioAvailableActions_Request {

    constructor(data?: IGetPortfolioAvailableActions_Request) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): GetPortfolioAvailableActions_Request {
        data = typeof data === 'object' ? data : {};
        let result = new GetPortfolioAvailableActions_Request();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IGetPortfolioAvailableActions_Request {
}

export class GetPortfolioBalance_Response implements IGetPortfolioBalance_Response {
    holdingsBalanceIncludingReservations?: number;
    holdingsBalanceExcludingReservations?: number;
    settledContributions?: GetPortfolioBalance_Response_ContributionsResponse | undefined;
    incomingContributions?: GetPortfolioBalance_Response_ContributionsResponse | undefined;
    simpleReturn?: GetPortfolioBalance_Response_SimpleReturnResponse | undefined;

    constructor(data?: IGetPortfolioBalance_Response) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.holdingsBalanceIncludingReservations = _data["holdingsBalanceIncludingReservations"];
            this.holdingsBalanceExcludingReservations = _data["holdingsBalanceExcludingReservations"];
            this.settledContributions = _data["settledContributions"] ? GetPortfolioBalance_Response_ContributionsResponse.fromJS(_data["settledContributions"]) : <any>undefined;
            this.incomingContributions = _data["incomingContributions"] ? GetPortfolioBalance_Response_ContributionsResponse.fromJS(_data["incomingContributions"]) : <any>undefined;
            this.simpleReturn = _data["simpleReturn"] ? GetPortfolioBalance_Response_SimpleReturnResponse.fromJS(_data["simpleReturn"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetPortfolioBalance_Response {
        data = typeof data === 'object' ? data : {};
        let result = new GetPortfolioBalance_Response();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["holdingsBalanceIncludingReservations"] = this.holdingsBalanceIncludingReservations;
        data["holdingsBalanceExcludingReservations"] = this.holdingsBalanceExcludingReservations;
        data["settledContributions"] = this.settledContributions ? this.settledContributions.toJSON() : <any>undefined;
        data["incomingContributions"] = this.incomingContributions ? this.incomingContributions.toJSON() : <any>undefined;
        data["simpleReturn"] = this.simpleReturn ? this.simpleReturn.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetPortfolioBalance_Response {
    holdingsBalanceIncludingReservations?: number;
    holdingsBalanceExcludingReservations?: number;
    settledContributions?: GetPortfolioBalance_Response_ContributionsResponse | undefined;
    incomingContributions?: GetPortfolioBalance_Response_ContributionsResponse | undefined;
    simpleReturn?: GetPortfolioBalance_Response_SimpleReturnResponse | undefined;
}

export class GetPortfolioBalance_Response_ContributionsResponse implements IGetPortfolioBalance_Response_ContributionsResponse {
    currentTaxYear?: number;
    total?: number;

    constructor(data?: IGetPortfolioBalance_Response_ContributionsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.currentTaxYear = _data["currentTaxYear"];
            this.total = _data["total"];
        }
    }

    static fromJS(data: any): GetPortfolioBalance_Response_ContributionsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetPortfolioBalance_Response_ContributionsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currentTaxYear"] = this.currentTaxYear;
        data["total"] = this.total;
        return data;
    }
}

export interface IGetPortfolioBalance_Response_ContributionsResponse {
    currentTaxYear?: number;
    total?: number;
}

export class GetPortfolioBalance_Response_SimpleReturnResponse implements IGetPortfolioBalance_Response_SimpleReturnResponse {
    percentage?: number;
    value?: number;

    constructor(data?: IGetPortfolioBalance_Response_SimpleReturnResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.percentage = _data["percentage"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): GetPortfolioBalance_Response_SimpleReturnResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetPortfolioBalance_Response_SimpleReturnResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["percentage"] = this.percentage;
        data["value"] = this.value;
        return data;
    }
}

export interface IGetPortfolioBalance_Response_SimpleReturnResponse {
    percentage?: number;
    value?: number;
}

export class GetPortfolioBalance_Request implements IGetPortfolioBalance_Request {

    constructor(data?: IGetPortfolioBalance_Request) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): GetPortfolioBalance_Request {
        data = typeof data === 'object' ? data : {};
        let result = new GetPortfolioBalance_Request();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IGetPortfolioBalance_Request {
}

export class GetPortfolioFees_Response implements IGetPortfolioFees_Response {
    fees?: GetPortfolioFees_FeeResponse[] | undefined;

    constructor(data?: IGetPortfolioFees_Response) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["fees"])) {
                this.fees = [] as any;
                for (let item of _data["fees"])
                    this.fees!.push(GetPortfolioFees_FeeResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetPortfolioFees_Response {
        data = typeof data === 'object' ? data : {};
        let result = new GetPortfolioFees_Response();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.fees)) {
            data["fees"] = [];
            for (let item of this.fees)
                data["fees"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetPortfolioFees_Response {
    fees?: GetPortfolioFees_FeeResponse[] | undefined;
}

export class GetPortfolioFees_FeeResponse implements IGetPortfolioFees_FeeResponse {
    monthYear?: Date;
    collectedAmount?: number | undefined;
    status?: string | undefined;
    collectionDate?: Date | undefined;

    constructor(data?: IGetPortfolioFees_FeeResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.monthYear = _data["monthYear"] ? new Date(_data["monthYear"].toString()) : <any>undefined;
            this.collectedAmount = _data["collectedAmount"];
            this.status = _data["status"];
            this.collectionDate = _data["collectionDate"] ? new Date(_data["collectionDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): GetPortfolioFees_FeeResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetPortfolioFees_FeeResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["monthYear"] = this.monthYear ? formatDate(this.monthYear) : <any>undefined;
        data["collectedAmount"] = this.collectedAmount;
        data["status"] = this.status;
        data["collectionDate"] = this.collectionDate ? this.collectionDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IGetPortfolioFees_FeeResponse {
    monthYear?: Date;
    collectedAmount?: number | undefined;
    status?: string | undefined;
    collectionDate?: Date | undefined;
}

export class GetPortfolioFees_Request implements IGetPortfolioFees_Request {

    constructor(data?: IGetPortfolioFees_Request) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): GetPortfolioFees_Request {
        data = typeof data === 'object' ? data : {};
        let result = new GetPortfolioFees_Request();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IGetPortfolioFees_Request {
}

export class GetPortfolioRequestsForAccount_Response_Root implements IGetPortfolioRequestsForAccount_Response_Root {
    portfolios?: GetPortfolioRequestsForAccount_Response_Portfolio[] | undefined;

    constructor(data?: IGetPortfolioRequestsForAccount_Response_Root) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["portfolios"])) {
                this.portfolios = [] as any;
                for (let item of _data["portfolios"])
                    this.portfolios!.push(GetPortfolioRequestsForAccount_Response_Portfolio.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetPortfolioRequestsForAccount_Response_Root {
        data = typeof data === 'object' ? data : {};
        let result = new GetPortfolioRequestsForAccount_Response_Root();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.portfolios)) {
            data["portfolios"] = [];
            for (let item of this.portfolios)
                data["portfolios"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetPortfolioRequestsForAccount_Response_Root {
    portfolios?: GetPortfolioRequestsForAccount_Response_Portfolio[] | undefined;
}

export class GetPortfolioRequestsForAccount_Response_Portfolio implements IGetPortfolioRequestsForAccount_Response_Portfolio {
    id?: string;
    submitted?: boolean;

    constructor(data?: IGetPortfolioRequestsForAccount_Response_Portfolio) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.submitted = _data["submitted"];
        }
    }

    static fromJS(data: any): GetPortfolioRequestsForAccount_Response_Portfolio {
        data = typeof data === 'object' ? data : {};
        let result = new GetPortfolioRequestsForAccount_Response_Portfolio();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["submitted"] = this.submitted;
        return data;
    }
}

export interface IGetPortfolioRequestsForAccount_Response_Portfolio {
    id?: string;
    submitted?: boolean;
}

export class GetPortfolioRequestsForAccount_Request_Root implements IGetPortfolioRequestsForAccount_Request_Root {

    constructor(data?: IGetPortfolioRequestsForAccount_Request_Root) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): GetPortfolioRequestsForAccount_Request_Root {
        data = typeof data === 'object' ? data : {};
        let result = new GetPortfolioRequestsForAccount_Request_Root();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IGetPortfolioRequestsForAccount_Request_Root {
}

export class GetPortfoliosForAccount_Response_Root implements IGetPortfoliosForAccount_Response_Root {
    portfolios?: GetPortfoliosForAccount_Response_Portfolio[] | undefined;

    constructor(data?: IGetPortfoliosForAccount_Response_Root) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["portfolios"])) {
                this.portfolios = [] as any;
                for (let item of _data["portfolios"])
                    this.portfolios!.push(GetPortfoliosForAccount_Response_Portfolio.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetPortfoliosForAccount_Response_Root {
        data = typeof data === 'object' ? data : {};
        let result = new GetPortfoliosForAccount_Response_Root();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.portfolios)) {
            data["portfolios"] = [];
            for (let item of this.portfolios)
                data["portfolios"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetPortfoliosForAccount_Response_Root {
    portfolios?: GetPortfoliosForAccount_Response_Portfolio[] | undefined;
}

export class GetPortfoliosForAccount_Response_Portfolio implements IGetPortfoliosForAccount_Response_Portfolio {
    id?: string;
    submitted?: boolean;
    fundAllocations?: GetPortfoliosForAccount_Response_FundAllocation[] | undefined;

    constructor(data?: IGetPortfoliosForAccount_Response_Portfolio) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.submitted = _data["submitted"];
            if (Array.isArray(_data["fundAllocations"])) {
                this.fundAllocations = [] as any;
                for (let item of _data["fundAllocations"])
                    this.fundAllocations!.push(GetPortfoliosForAccount_Response_FundAllocation.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetPortfoliosForAccount_Response_Portfolio {
        data = typeof data === 'object' ? data : {};
        let result = new GetPortfoliosForAccount_Response_Portfolio();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["submitted"] = this.submitted;
        if (Array.isArray(this.fundAllocations)) {
            data["fundAllocations"] = [];
            for (let item of this.fundAllocations)
                data["fundAllocations"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetPortfoliosForAccount_Response_Portfolio {
    id?: string;
    submitted?: boolean;
    fundAllocations?: GetPortfoliosForAccount_Response_FundAllocation[] | undefined;
}

export class GetPortfoliosForAccount_Response_FundAllocation implements IGetPortfoliosForAccount_Response_FundAllocation {
    fundIsin?: string | undefined;
    allocationPercentage?: number;

    constructor(data?: IGetPortfoliosForAccount_Response_FundAllocation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fundIsin = _data["fundIsin"];
            this.allocationPercentage = _data["allocationPercentage"];
        }
    }

    static fromJS(data: any): GetPortfoliosForAccount_Response_FundAllocation {
        data = typeof data === 'object' ? data : {};
        let result = new GetPortfoliosForAccount_Response_FundAllocation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fundIsin"] = this.fundIsin;
        data["allocationPercentage"] = this.allocationPercentage;
        return data;
    }
}

export interface IGetPortfoliosForAccount_Response_FundAllocation {
    fundIsin?: string | undefined;
    allocationPercentage?: number;
}

export class GetPortfoliosForAccount_Request_Root implements IGetPortfoliosForAccount_Request_Root {

    constructor(data?: IGetPortfoliosForAccount_Request_Root) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): GetPortfoliosForAccount_Request_Root {
        data = typeof data === 'object' ? data : {};
        let result = new GetPortfoliosForAccount_Request_Root();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IGetPortfoliosForAccount_Request_Root {
}

export class GetPortfolioTransactions_Response implements IGetPortfolioTransactions_Response {
    transactions?: GetPortfolioTransactions_TransactionResponse[] | undefined;

    constructor(data?: IGetPortfolioTransactions_Response) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["transactions"])) {
                this.transactions = [] as any;
                for (let item of _data["transactions"])
                    this.transactions!.push(GetPortfolioTransactions_TransactionResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetPortfolioTransactions_Response {
        data = typeof data === 'object' ? data : {};
        let result = new GetPortfolioTransactions_Response();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.transactions)) {
            data["transactions"] = [];
            for (let item of this.transactions)
                data["transactions"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetPortfolioTransactions_Response {
    transactions?: GetPortfolioTransactions_TransactionResponse[] | undefined;
}

export class GetPortfolioTransactions_TransactionResponse implements IGetPortfolioTransactions_TransactionResponse {
    dateRequested?: Date;
    type?: GetPortfolioTransactions_TransactionType;
    status?: string | undefined;
    amount?: number | undefined;
    transactionId?: string;

    constructor(data?: IGetPortfolioTransactions_TransactionResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dateRequested = _data["dateRequested"] ? new Date(_data["dateRequested"].toString()) : <any>undefined;
            this.type = _data["type"];
            this.status = _data["status"];
            this.amount = _data["amount"];
            this.transactionId = _data["transactionId"];
        }
    }

    static fromJS(data: any): GetPortfolioTransactions_TransactionResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetPortfolioTransactions_TransactionResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dateRequested"] = this.dateRequested ? this.dateRequested.toISOString() : <any>undefined;
        data["type"] = this.type;
        data["status"] = this.status;
        data["amount"] = this.amount;
        data["transactionId"] = this.transactionId;
        return data;
    }
}

export interface IGetPortfolioTransactions_TransactionResponse {
    dateRequested?: Date;
    type?: GetPortfolioTransactions_TransactionType;
    status?: string | undefined;
    amount?: number | undefined;
    transactionId?: string;
}

export enum GetPortfolioTransactions_TransactionType {
    Deposit = "Deposit",
    Withdrawal = "Withdrawal",
    Rebalance = "Rebalance",
}

export class GetPortfolioTransactions_Request implements IGetPortfolioTransactions_Request {

    constructor(data?: IGetPortfolioTransactions_Request) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): GetPortfolioTransactions_Request {
        data = typeof data === 'object' ? data : {};
        let result = new GetPortfolioTransactions_Request();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IGetPortfolioTransactions_Request {
}

export class GetPortfolioValuations_Response implements IGetPortfolioValuations_Response {
    valuations?: GetPortfolioValuations_Response_ValuationItem[] | undefined;

    constructor(data?: IGetPortfolioValuations_Response) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["valuations"])) {
                this.valuations = [] as any;
                for (let item of _data["valuations"])
                    this.valuations!.push(GetPortfolioValuations_Response_ValuationItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetPortfolioValuations_Response {
        data = typeof data === 'object' ? data : {};
        let result = new GetPortfolioValuations_Response();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.valuations)) {
            data["valuations"] = [];
            for (let item of this.valuations)
                data["valuations"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetPortfolioValuations_Response {
    valuations?: GetPortfolioValuations_Response_ValuationItem[] | undefined;
}

export class GetPortfolioValuations_Response_ValuationItem implements IGetPortfolioValuations_Response_ValuationItem {
    date?: Date;
    value?: number;
    currency?: string | undefined;

    constructor(data?: IGetPortfolioValuations_Response_ValuationItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
            this.value = _data["value"];
            this.currency = _data["currency"];
        }
    }

    static fromJS(data: any): GetPortfolioValuations_Response_ValuationItem {
        data = typeof data === 'object' ? data : {};
        let result = new GetPortfolioValuations_Response_ValuationItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["value"] = this.value;
        data["currency"] = this.currency;
        return data;
    }
}

export interface IGetPortfolioValuations_Response_ValuationItem {
    date?: Date;
    value?: number;
    currency?: string | undefined;
}

export class GetPortfolioValuations_Request implements IGetPortfolioValuations_Request {

    constructor(data?: IGetPortfolioValuations_Request) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): GetPortfolioValuations_Request {
        data = typeof data === 'object' ? data : {};
        let result = new GetPortfolioValuations_Request();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IGetPortfolioValuations_Request {
}

export class MakeWithdrawal_Request implements IMakeWithdrawal_Request {
    amount?: number;

    constructor(data?: IMakeWithdrawal_Request) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.amount = _data["amount"];
        }
    }

    static fromJS(data: any): MakeWithdrawal_Request {
        data = typeof data === 'object' ? data : {};
        let result = new MakeWithdrawal_Request();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["amount"] = this.amount;
        return data;
    }
}

export interface IMakeWithdrawal_Request {
    amount?: number;
}

export class RequestDepositToPortfolio_Response implements IRequestDepositToPortfolio_Response {
    depositId?: string;

    constructor(data?: IRequestDepositToPortfolio_Response) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.depositId = _data["depositId"];
        }
    }

    static fromJS(data: any): RequestDepositToPortfolio_Response {
        data = typeof data === 'object' ? data : {};
        let result = new RequestDepositToPortfolio_Response();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["depositId"] = this.depositId;
        return data;
    }
}

export interface IRequestDepositToPortfolio_Response {
    depositId?: string;
}

export class RequestDepositToPortfolio_Request implements IRequestDepositToPortfolio_Request {
    amount?: number;
    referenceOverrideAdminOnly?: string | undefined;

    constructor(data?: IRequestDepositToPortfolio_Request) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.amount = _data["amount"];
            this.referenceOverrideAdminOnly = _data["referenceOverrideAdminOnly"];
        }
    }

    static fromJS(data: any): RequestDepositToPortfolio_Request {
        data = typeof data === 'object' ? data : {};
        let result = new RequestDepositToPortfolio_Request();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["amount"] = this.amount;
        data["referenceOverrideAdminOnly"] = this.referenceOverrideAdminOnly;
        return data;
    }
}

export interface IRequestDepositToPortfolio_Request {
    amount?: number;
    referenceOverrideAdminOnly?: string | undefined;
}

export class RequestPlaidDepositToPortfolio_Response implements IRequestPlaidDepositToPortfolio_Response {
    linkToken?: string | undefined;
    expiration?: Date | undefined;
    error?: RequestPlaidDepositToPortfolio_ErrorDetail | undefined;
    isSuccess?: boolean;

    constructor(data?: IRequestPlaidDepositToPortfolio_Response) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.linkToken = _data["linkToken"];
            this.expiration = _data["expiration"] ? new Date(_data["expiration"].toString()) : <any>undefined;
            this.error = _data["error"] ? RequestPlaidDepositToPortfolio_ErrorDetail.fromJS(_data["error"]) : <any>undefined;
            this.isSuccess = _data["isSuccess"];
        }
    }

    static fromJS(data: any): RequestPlaidDepositToPortfolio_Response {
        data = typeof data === 'object' ? data : {};
        let result = new RequestPlaidDepositToPortfolio_Response();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["linkToken"] = this.linkToken;
        data["expiration"] = this.expiration ? this.expiration.toISOString() : <any>undefined;
        data["error"] = this.error ? this.error.toJSON() : <any>undefined;
        data["isSuccess"] = this.isSuccess;
        return data;
    }
}

export interface IRequestPlaidDepositToPortfolio_Response {
    linkToken?: string | undefined;
    expiration?: Date | undefined;
    error?: RequestPlaidDepositToPortfolio_ErrorDetail | undefined;
    isSuccess?: boolean;
}

export class RequestPlaidDepositToPortfolio_ErrorDetail implements IRequestPlaidDepositToPortfolio_ErrorDetail {
    type?: string | undefined;
    code?: string | undefined;
    message?: string | undefined;

    constructor(data?: IRequestPlaidDepositToPortfolio_ErrorDetail) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"];
            this.code = _data["code"];
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): RequestPlaidDepositToPortfolio_ErrorDetail {
        data = typeof data === 'object' ? data : {};
        let result = new RequestPlaidDepositToPortfolio_ErrorDetail();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["code"] = this.code;
        data["message"] = this.message;
        return data;
    }
}

export interface IRequestPlaidDepositToPortfolio_ErrorDetail {
    type?: string | undefined;
    code?: string | undefined;
    message?: string | undefined;
}

export class RequestPlaidDepositToPortfolio_Request implements IRequestPlaidDepositToPortfolio_Request {
    amount?: number;
    devicePlatform?: string | undefined;
    redirectUri?: string | undefined;
    schedule?: PropelleSharedPlaidClientRequestedSchedule | undefined;

    constructor(data?: IRequestPlaidDepositToPortfolio_Request) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.amount = _data["amount"];
            this.devicePlatform = _data["devicePlatform"];
            this.redirectUri = _data["redirectUri"];
            this.schedule = _data["schedule"] ? PropelleSharedPlaidClientRequestedSchedule.fromJS(_data["schedule"]) : <any>undefined;
        }
    }

    static fromJS(data: any): RequestPlaidDepositToPortfolio_Request {
        data = typeof data === 'object' ? data : {};
        let result = new RequestPlaidDepositToPortfolio_Request();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["amount"] = this.amount;
        data["devicePlatform"] = this.devicePlatform;
        data["redirectUri"] = this.redirectUri;
        data["schedule"] = this.schedule ? this.schedule.toJSON() : <any>undefined;
        return data;
    }
}

export interface IRequestPlaidDepositToPortfolio_Request {
    amount?: number;
    devicePlatform?: string | undefined;
    redirectUri?: string | undefined;
    schedule?: PropelleSharedPlaidClientRequestedSchedule | undefined;
}

export class PropelleSharedPlaidClientRequestedSchedule implements IPropelleSharedPlaidClientRequestedSchedule {
    interval?: PropelleSharedPlaidRequestsInterval;
    startDate?: Date;

    constructor(data?: IPropelleSharedPlaidClientRequestedSchedule) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.interval = _data["interval"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): PropelleSharedPlaidClientRequestedSchedule {
        data = typeof data === 'object' ? data : {};
        let result = new PropelleSharedPlaidClientRequestedSchedule();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["interval"] = this.interval;
        data["startDate"] = this.startDate ? formatDate(this.startDate) : <any>undefined;
        return data;
    }
}

export interface IPropelleSharedPlaidClientRequestedSchedule {
    interval?: PropelleSharedPlaidRequestsInterval;
    startDate?: Date;
}

export enum PropelleSharedPlaidRequestsInterval {
    Weekly = "Weekly",
    Monthly = "Monthly",
}

export class RequestRebalance_Request implements IRequestRebalance_Request {
    fundAllocations!: RequestRebalance_Request_FundAllocation[];

    constructor(data?: IRequestRebalance_Request) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.fundAllocations = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["fundAllocations"])) {
                this.fundAllocations = [] as any;
                for (let item of _data["fundAllocations"])
                    this.fundAllocations!.push(RequestRebalance_Request_FundAllocation.fromJS(item));
            }
        }
    }

    static fromJS(data: any): RequestRebalance_Request {
        data = typeof data === 'object' ? data : {};
        let result = new RequestRebalance_Request();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.fundAllocations)) {
            data["fundAllocations"] = [];
            for (let item of this.fundAllocations)
                data["fundAllocations"].push(item.toJSON());
        }
        return data;
    }
}

export interface IRequestRebalance_Request {
    fundAllocations: RequestRebalance_Request_FundAllocation[];
}

export class RequestRebalance_Request_FundAllocation implements IRequestRebalance_Request_FundAllocation {
    fundIsin?: string | undefined;
    allocationPercentage?: number;

    constructor(data?: IRequestRebalance_Request_FundAllocation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fundIsin = _data["fundIsin"];
            this.allocationPercentage = _data["allocationPercentage"];
        }
    }

    static fromJS(data: any): RequestRebalance_Request_FundAllocation {
        data = typeof data === 'object' ? data : {};
        let result = new RequestRebalance_Request_FundAllocation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fundIsin"] = this.fundIsin;
        data["allocationPercentage"] = this.allocationPercentage;
        return data;
    }
}

export interface IRequestRebalance_Request_FundAllocation {
    fundIsin?: string | undefined;
    allocationPercentage?: number;
}

export class RequestUnlinkedPlaidDepositToPortfolio_Response implements IRequestUnlinkedPlaidDepositToPortfolio_Response {
    linkToken?: string | undefined;
    expiration?: Date | undefined;
    error?: RequestUnlinkedPlaidDepositToPortfolio_ErrorDetail | undefined;
    isSuccess?: boolean;

    constructor(data?: IRequestUnlinkedPlaidDepositToPortfolio_Response) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.linkToken = _data["linkToken"];
            this.expiration = _data["expiration"] ? new Date(_data["expiration"].toString()) : <any>undefined;
            this.error = _data["error"] ? RequestUnlinkedPlaidDepositToPortfolio_ErrorDetail.fromJS(_data["error"]) : <any>undefined;
            this.isSuccess = _data["isSuccess"];
        }
    }

    static fromJS(data: any): RequestUnlinkedPlaidDepositToPortfolio_Response {
        data = typeof data === 'object' ? data : {};
        let result = new RequestUnlinkedPlaidDepositToPortfolio_Response();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["linkToken"] = this.linkToken;
        data["expiration"] = this.expiration ? this.expiration.toISOString() : <any>undefined;
        data["error"] = this.error ? this.error.toJSON() : <any>undefined;
        data["isSuccess"] = this.isSuccess;
        return data;
    }
}

export interface IRequestUnlinkedPlaidDepositToPortfolio_Response {
    linkToken?: string | undefined;
    expiration?: Date | undefined;
    error?: RequestUnlinkedPlaidDepositToPortfolio_ErrorDetail | undefined;
    isSuccess?: boolean;
}

export class RequestUnlinkedPlaidDepositToPortfolio_ErrorDetail implements IRequestUnlinkedPlaidDepositToPortfolio_ErrorDetail {
    type?: string | undefined;
    code?: string | undefined;
    message?: string | undefined;

    constructor(data?: IRequestUnlinkedPlaidDepositToPortfolio_ErrorDetail) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"];
            this.code = _data["code"];
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): RequestUnlinkedPlaidDepositToPortfolio_ErrorDetail {
        data = typeof data === 'object' ? data : {};
        let result = new RequestUnlinkedPlaidDepositToPortfolio_ErrorDetail();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["code"] = this.code;
        data["message"] = this.message;
        return data;
    }
}

export interface IRequestUnlinkedPlaidDepositToPortfolio_ErrorDetail {
    type?: string | undefined;
    code?: string | undefined;
    message?: string | undefined;
}

export class RequestUnlinkedPlaidDepositToPortfolio_Request implements IRequestUnlinkedPlaidDepositToPortfolio_Request {
    amount?: number;
    devicePlatform?: string | undefined;
    redirectUri?: string | undefined;

    constructor(data?: IRequestUnlinkedPlaidDepositToPortfolio_Request) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.amount = _data["amount"];
            this.devicePlatform = _data["devicePlatform"];
            this.redirectUri = _data["redirectUri"];
        }
    }

    static fromJS(data: any): RequestUnlinkedPlaidDepositToPortfolio_Request {
        data = typeof data === 'object' ? data : {};
        let result = new RequestUnlinkedPlaidDepositToPortfolio_Request();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["amount"] = this.amount;
        data["devicePlatform"] = this.devicePlatform;
        data["redirectUri"] = this.redirectUri;
        return data;
    }
}

export interface IRequestUnlinkedPlaidDepositToPortfolio_Request {
    amount?: number;
    devicePlatform?: string | undefined;
    redirectUri?: string | undefined;
}

export class TradingInternalApiHealthCheck_Response implements ITradingInternalApiHealthCheck_Response {
    isHealthy?: boolean;
    message?: string | undefined;

    constructor(data?: ITradingInternalApiHealthCheck_Response) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isHealthy = _data["isHealthy"];
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): TradingInternalApiHealthCheck_Response {
        data = typeof data === 'object' ? data : {};
        let result = new TradingInternalApiHealthCheck_Response();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isHealthy"] = this.isHealthy;
        data["message"] = this.message;
        return data;
    }
}

export interface ITradingInternalApiHealthCheck_Response {
    isHealthy?: boolean;
    message?: string | undefined;
}

export class UpdatePortfolioFundSelection_Request_Root implements IUpdatePortfolioFundSelection_Request_Root {
    fundAllocations!: UpdatePortfolioFundSelection_Request_FundAllocation[];

    constructor(data?: IUpdatePortfolioFundSelection_Request_Root) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.fundAllocations = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["fundAllocations"])) {
                this.fundAllocations = [] as any;
                for (let item of _data["fundAllocations"])
                    this.fundAllocations!.push(UpdatePortfolioFundSelection_Request_FundAllocation.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdatePortfolioFundSelection_Request_Root {
        data = typeof data === 'object' ? data : {};
        let result = new UpdatePortfolioFundSelection_Request_Root();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.fundAllocations)) {
            data["fundAllocations"] = [];
            for (let item of this.fundAllocations)
                data["fundAllocations"].push(item.toJSON());
        }
        return data;
    }
}

export interface IUpdatePortfolioFundSelection_Request_Root {
    fundAllocations: UpdatePortfolioFundSelection_Request_FundAllocation[];
}

export class UpdatePortfolioFundSelection_Request_FundAllocation implements IUpdatePortfolioFundSelection_Request_FundAllocation {
    fundIsin?: string | undefined;
    allocationPercentage?: number;

    constructor(data?: IUpdatePortfolioFundSelection_Request_FundAllocation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fundIsin = _data["fundIsin"];
            this.allocationPercentage = _data["allocationPercentage"];
        }
    }

    static fromJS(data: any): UpdatePortfolioFundSelection_Request_FundAllocation {
        data = typeof data === 'object' ? data : {};
        let result = new UpdatePortfolioFundSelection_Request_FundAllocation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fundIsin"] = this.fundIsin;
        data["allocationPercentage"] = this.allocationPercentage;
        return data;
    }
}

export interface IUpdatePortfolioFundSelection_Request_FundAllocation {
    fundIsin?: string | undefined;
    allocationPercentage?: number;
}

export class GiftCreateJisaGiftLink_Response implements IGiftCreateJisaGiftLink_Response {
    inviteUrl?: string | undefined;
    inviteToken?: string | undefined;
    expiresAt?: Date;
    inviteId?: string;

    constructor(data?: IGiftCreateJisaGiftLink_Response) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.inviteUrl = _data["inviteUrl"];
            this.inviteToken = _data["inviteToken"];
            this.expiresAt = _data["expiresAt"] ? new Date(_data["expiresAt"].toString()) : <any>undefined;
            this.inviteId = _data["inviteId"];
        }
    }

    static fromJS(data: any): GiftCreateJisaGiftLink_Response {
        data = typeof data === 'object' ? data : {};
        let result = new GiftCreateJisaGiftLink_Response();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["inviteUrl"] = this.inviteUrl;
        data["inviteToken"] = this.inviteToken;
        data["expiresAt"] = this.expiresAt ? this.expiresAt.toISOString() : <any>undefined;
        data["inviteId"] = this.inviteId;
        return data;
    }
}

export interface IGiftCreateJisaGiftLink_Response {
    inviteUrl?: string | undefined;
    inviteToken?: string | undefined;
    expiresAt?: Date;
    inviteId?: string;
}

export class GiftCreateJisaGiftLink_Request implements IGiftCreateJisaGiftLink_Request {

    constructor(data?: IGiftCreateJisaGiftLink_Request) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): GiftCreateJisaGiftLink_Request {
        data = typeof data === 'object' ? data : {};
        let result = new GiftCreateJisaGiftLink_Request();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IGiftCreateJisaGiftLink_Request {
}

export class GiftGetGiftPayments_Response_Root implements IGiftGetGiftPayments_Response_Root {
    giftNotes?: GiftGetGiftPayments_Response_GiftNote[] | undefined;

    constructor(data?: IGiftGetGiftPayments_Response_Root) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["giftNotes"])) {
                this.giftNotes = [] as any;
                for (let item of _data["giftNotes"])
                    this.giftNotes!.push(GiftGetGiftPayments_Response_GiftNote.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GiftGetGiftPayments_Response_Root {
        data = typeof data === 'object' ? data : {};
        let result = new GiftGetGiftPayments_Response_Root();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.giftNotes)) {
            data["giftNotes"] = [];
            for (let item of this.giftNotes)
                data["giftNotes"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGiftGetGiftPayments_Response_Root {
    giftNotes?: GiftGetGiftPayments_Response_GiftNote[] | undefined;
}

export class GiftGetGiftPayments_Response_GiftNote implements IGiftGetGiftPayments_Response_GiftNote {
    paymentId?: string | undefined;
    guestName?: string | undefined;
    relationship?: string | undefined;
    amount?: number;
    note?: string | undefined;
    isRead?: boolean | undefined;
    completedAt?: Date;

    constructor(data?: IGiftGetGiftPayments_Response_GiftNote) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.paymentId = _data["paymentId"];
            this.guestName = _data["guestName"];
            this.relationship = _data["relationship"];
            this.amount = _data["amount"];
            this.note = _data["note"];
            this.isRead = _data["isRead"];
            this.completedAt = _data["completedAt"] ? new Date(_data["completedAt"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): GiftGetGiftPayments_Response_GiftNote {
        data = typeof data === 'object' ? data : {};
        let result = new GiftGetGiftPayments_Response_GiftNote();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["paymentId"] = this.paymentId;
        data["guestName"] = this.guestName;
        data["relationship"] = this.relationship;
        data["amount"] = this.amount;
        data["note"] = this.note;
        data["isRead"] = this.isRead;
        data["completedAt"] = this.completedAt ? this.completedAt.toISOString() : <any>undefined;
        return data;
    }
}

export interface IGiftGetGiftPayments_Response_GiftNote {
    paymentId?: string | undefined;
    guestName?: string | undefined;
    relationship?: string | undefined;
    amount?: number;
    note?: string | undefined;
    isRead?: boolean | undefined;
    completedAt?: Date;
}

export class GiftGetGiftPayments_Request implements IGiftGetGiftPayments_Request {

    constructor(data?: IGiftGetGiftPayments_Request) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): GiftGetGiftPayments_Request {
        data = typeof data === 'object' ? data : {};
        let result = new GiftGetGiftPayments_Request();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IGiftGetGiftPayments_Request {
}

export class GiftGetJisaGiftLinks_Response_Root implements IGiftGetJisaGiftLinks_Response_Root {
    giftLinks?: GiftGetJisaGiftLinks_Response_GiftLink[] | undefined;

    constructor(data?: IGiftGetJisaGiftLinks_Response_Root) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["giftLinks"])) {
                this.giftLinks = [] as any;
                for (let item of _data["giftLinks"])
                    this.giftLinks!.push(GiftGetJisaGiftLinks_Response_GiftLink.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GiftGetJisaGiftLinks_Response_Root {
        data = typeof data === 'object' ? data : {};
        let result = new GiftGetJisaGiftLinks_Response_Root();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.giftLinks)) {
            data["giftLinks"] = [];
            for (let item of this.giftLinks)
                data["giftLinks"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGiftGetJisaGiftLinks_Response_Root {
    giftLinks?: GiftGetJisaGiftLinks_Response_GiftLink[] | undefined;
}

export class GiftGetJisaGiftLinks_Response_GiftLink implements IGiftGetJisaGiftLinks_Response_GiftLink {
    inviteId?: string;
    inviteToken?: string | undefined;
    status?: string | undefined;
    createdAt?: Date;
    expiresAt?: Date;
    usedAt?: Date | undefined;
    revokedAt?: Date | undefined;

    constructor(data?: IGiftGetJisaGiftLinks_Response_GiftLink) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.inviteId = _data["inviteId"];
            this.inviteToken = _data["inviteToken"];
            this.status = _data["status"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>undefined;
            this.expiresAt = _data["expiresAt"] ? new Date(_data["expiresAt"].toString()) : <any>undefined;
            this.usedAt = _data["usedAt"] ? new Date(_data["usedAt"].toString()) : <any>undefined;
            this.revokedAt = _data["revokedAt"] ? new Date(_data["revokedAt"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): GiftGetJisaGiftLinks_Response_GiftLink {
        data = typeof data === 'object' ? data : {};
        let result = new GiftGetJisaGiftLinks_Response_GiftLink();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["inviteId"] = this.inviteId;
        data["inviteToken"] = this.inviteToken;
        data["status"] = this.status;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["expiresAt"] = this.expiresAt ? this.expiresAt.toISOString() : <any>undefined;
        data["usedAt"] = this.usedAt ? this.usedAt.toISOString() : <any>undefined;
        data["revokedAt"] = this.revokedAt ? this.revokedAt.toISOString() : <any>undefined;
        return data;
    }
}

export interface IGiftGetJisaGiftLinks_Response_GiftLink {
    inviteId?: string;
    inviteToken?: string | undefined;
    status?: string | undefined;
    createdAt?: Date;
    expiresAt?: Date;
    usedAt?: Date | undefined;
    revokedAt?: Date | undefined;
}

export class GiftGetJisaGiftLinks_Request implements IGiftGetJisaGiftLinks_Request {

    constructor(data?: IGiftGetJisaGiftLinks_Request) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): GiftGetJisaGiftLinks_Request {
        data = typeof data === 'object' ? data : {};
        let result = new GiftGetJisaGiftLinks_Request();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IGiftGetJisaGiftLinks_Request {
}

export class GiftMarkGiftNoteRead_Request implements IGiftMarkGiftNoteRead_Request {

    constructor(data?: IGiftMarkGiftNoteRead_Request) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): GiftMarkGiftNoteRead_Request {
        data = typeof data === 'object' ? data : {};
        let result = new GiftMarkGiftNoteRead_Request();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IGiftMarkGiftNoteRead_Request {
}

export class GiftRequestGuestGiftDeposit_Response implements IGiftRequestGuestGiftDeposit_Response {
    linkToken?: string | undefined;
    expiration?: Date | undefined;
    paymentId?: string | undefined;
    error?: GiftRequestGuestGiftDeposit_ErrorDetail | undefined;
    isSuccess?: boolean;

    constructor(data?: IGiftRequestGuestGiftDeposit_Response) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.linkToken = _data["linkToken"];
            this.expiration = _data["expiration"] ? new Date(_data["expiration"].toString()) : <any>undefined;
            this.paymentId = _data["paymentId"];
            this.error = _data["error"] ? GiftRequestGuestGiftDeposit_ErrorDetail.fromJS(_data["error"]) : <any>undefined;
            this.isSuccess = _data["isSuccess"];
        }
    }

    static fromJS(data: any): GiftRequestGuestGiftDeposit_Response {
        data = typeof data === 'object' ? data : {};
        let result = new GiftRequestGuestGiftDeposit_Response();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["linkToken"] = this.linkToken;
        data["expiration"] = this.expiration ? this.expiration.toISOString() : <any>undefined;
        data["paymentId"] = this.paymentId;
        data["error"] = this.error ? this.error.toJSON() : <any>undefined;
        data["isSuccess"] = this.isSuccess;
        return data;
    }
}

export interface IGiftRequestGuestGiftDeposit_Response {
    linkToken?: string | undefined;
    expiration?: Date | undefined;
    paymentId?: string | undefined;
    error?: GiftRequestGuestGiftDeposit_ErrorDetail | undefined;
    isSuccess?: boolean;
}

export class GiftRequestGuestGiftDeposit_ErrorDetail implements IGiftRequestGuestGiftDeposit_ErrorDetail {
    type?: string | undefined;
    code?: string | undefined;
    message?: string | undefined;

    constructor(data?: IGiftRequestGuestGiftDeposit_ErrorDetail) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"];
            this.code = _data["code"];
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): GiftRequestGuestGiftDeposit_ErrorDetail {
        data = typeof data === 'object' ? data : {};
        let result = new GiftRequestGuestGiftDeposit_ErrorDetail();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["code"] = this.code;
        data["message"] = this.message;
        return data;
    }
}

export interface IGiftRequestGuestGiftDeposit_ErrorDetail {
    type?: string | undefined;
    code?: string | undefined;
    message?: string | undefined;
}

export class GiftRequestGuestGiftDeposit_Request implements IGiftRequestGuestGiftDeposit_Request {
    amount?: number;
    guestName!: string;
    relationship!: string;
    devicePlatform?: string | undefined;
    redirectUri?: string | undefined;

    constructor(data?: IGiftRequestGuestGiftDeposit_Request) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.amount = _data["amount"];
            this.guestName = _data["guestName"];
            this.relationship = _data["relationship"];
            this.devicePlatform = _data["devicePlatform"];
            this.redirectUri = _data["redirectUri"];
        }
    }

    static fromJS(data: any): GiftRequestGuestGiftDeposit_Request {
        data = typeof data === 'object' ? data : {};
        let result = new GiftRequestGuestGiftDeposit_Request();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["amount"] = this.amount;
        data["guestName"] = this.guestName;
        data["relationship"] = this.relationship;
        data["devicePlatform"] = this.devicePlatform;
        data["redirectUri"] = this.redirectUri;
        return data;
    }
}

export interface IGiftRequestGuestGiftDeposit_Request {
    amount?: number;
    guestName: string;
    relationship: string;
    devicePlatform?: string | undefined;
    redirectUri?: string | undefined;
}

export class GiftRevokeJisaGiftLink_Request implements IGiftRevokeJisaGiftLink_Request {

    constructor(data?: IGiftRevokeJisaGiftLink_Request) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): GiftRevokeJisaGiftLink_Request {
        data = typeof data === 'object' ? data : {};
        let result = new GiftRevokeJisaGiftLink_Request();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IGiftRevokeJisaGiftLink_Request {
}

export class GiftSubmitGiftNote_Response implements IGiftSubmitGiftNote_Response {
    isSuccess?: boolean;
    errorMessage?: string | undefined;

    constructor(data?: IGiftSubmitGiftNote_Response) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isSuccess = _data["isSuccess"];
            this.errorMessage = _data["errorMessage"];
        }
    }

    static fromJS(data: any): GiftSubmitGiftNote_Response {
        data = typeof data === 'object' ? data : {};
        let result = new GiftSubmitGiftNote_Response();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isSuccess"] = this.isSuccess;
        data["errorMessage"] = this.errorMessage;
        return data;
    }
}

export interface IGiftSubmitGiftNote_Response {
    isSuccess?: boolean;
    errorMessage?: string | undefined;
}

export class GiftSubmitGiftNote_Request implements IGiftSubmitGiftNote_Request {
    paymentId!: string;
    note!: string;

    constructor(data?: IGiftSubmitGiftNote_Request) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.paymentId = _data["paymentId"];
            this.note = _data["note"];
        }
    }

    static fromJS(data: any): GiftSubmitGiftNote_Request {
        data = typeof data === 'object' ? data : {};
        let result = new GiftSubmitGiftNote_Request();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["paymentId"] = this.paymentId;
        data["note"] = this.note;
        return data;
    }
}

export interface IGiftSubmitGiftNote_Request {
    paymentId: string;
    note: string;
}

function formatDate(d: Date) {
    return d.getFullYear() + '-' + 
        (d.getMonth() < 9 ? ('0' + (d.getMonth()+1)) : (d.getMonth()+1)) + '-' +
        (d.getDate() < 10 ? ('0' + d.getDate()) : d.getDate());
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}